import { render, staticRenderFns } from "./ns-prompt-popup.vue?vue&type=template&id=22023812&"
import script from "./ns-prompt-popup.vue?vue&type=script&lang=js&"
export * from "./ns-prompt-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports